import {supportEntryLanguage} from './support-language';
import i18next from 'i18next';
import {initReactI18next} from 'react-i18next';
import {LANGUAGES,DEFAULT_LANGUAGE,readActiveLanguage} from './languages';
import ui from './ui-catalog.json';
import sourceCatalog from './source-catalog.json';
const legacy={'zh-Hant':require('../locales/ch/translations.json'),en:require('../locales/en/translations.json'),ja:require('../locales/jp/translations.json')};
function translatedTree(value,language,previous){
 if(typeof value==='string'){
  if(language==='zh-Hant')return value;
  const translated=sourceCatalog[language]&&sourceCatalog[language][value];
  return typeof translated==='string'&&translated.trim()?translated:typeof previous==='string'&&previous.trim()?previous:value;
 }
 if(Array.isArray(value))return value.map((item,index)=>translatedTree(item,language,previous&&previous[index]));
 if(value&&typeof value==='object'){
  const result={};Object.keys(value).forEach(key=>{result[key]=translatedTree(value[key],language,previous&&previous[key]);});return result;
 }
 return value;
}
const resources={};
LANGUAGES.forEach(({code})=>{resources[code]={translations:{...translatedTree(legacy['zh-Hant'],code,legacy[code]),UI:ui[code]||{}}};});
resources.ch=resources['zh-Hant'];resources.jp=resources.ja;
i18next.use(initReactI18next).init({
 lng:(typeof location!=='undefined'&&/^\/game-support\/?$/.test(location.pathname)&&supportEntryLanguage(location.search))||readActiveLanguage(),fallbackLng:DEFAULT_LANGUAGE,resources,ns:['translations'],defaultNS:'translations',
 returnObjects:true,returnEmptyString:false,initImmediate:false,debug:false,
 interpolation:{escapeValue:false},react:{useSuspense:false,bindI18n:'languageChanged loaded'}
});
export default i18next;
